import { render } from "./CrewList.vue?vue&type=template&id=022381ea"
import script from "./CrewList.vue?vue&type=script&lang=js"
export * from "./CrewList.vue?vue&type=script&lang=js"
script.render = render

export default script